import bindSocketUserEvents from './binds';

export default socketMiddleware => {
    bindSocketUserEvents(socketMiddleware);
    // let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    return {};
};



// WEBPACK FOOTER //
// ./environments/fhepool/eventsSocket/User/index.js